import React, {useEffect, useState} from "react"
import useAuth from "../../../../hooks/useAuth"
import imgNoData from "../../../../assets/theme/empty-state-no-data.svg" 
import Order from "./Order"
import {listApi} from "../../../../services/User/transaction";

export default function OrderHistoryClient() {
    const { logout } = useAuth()

    const [transactions, setTransactions] = useState([])
    const [noData, setNoData] = useState(false)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getBills()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    const getBills = async () => {
        listApi().then(response => {
            if (response.status) {
                const temp = response.data.data.map((doc) => {
                    return {
                        ...doc,
                    };
                });
                setTransactions(temp)

                if (temp.length === 0) {
                    setNoData(true)
                }
                setLoading(false)
            }
        
        }).catch(error => {
            console.error(error)
            setLoading(false)
        })
    }

    if (loading) return ""

    return (
        <>
            <div className="col-lg-9">
                <div className="card mb-3 mb-lg-5">
                    <div className="card-header">
                        <h5 className="card-header-title">
                            Facturas
                        </h5>
                    </div>

                    <div className="card-body">

                        <div>

                            <ul className="list-unstyled mb-5">
                                <li className="card card-bordered shadow-none mb-3">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-6 col-md mb-3 mb-md-0">
                                                <small className="card-subtitle mb-0">Número de factura</small>
                                            </div>

                                            <div className="col-6 col-md">
                                                <small className="card-subtitle mb-0">Fecha de emisión</small>
                                            </div>

                                            <div className="col-6 col-md">
                                                <small className="card-subtitle mb-0">Minutos</small>
                                            </div>

                                            <div className="col-6 col-md mb-3 mb-md-0">
                                                <small className="card-subtitle mb-0">Precio</small>
                                            </div>

                                            <div className="col-6 col-md mb-3 mb-md-0">
                                                <small className="card-subtitle mb-0">Factura</small>
                                            </div>

                                        </div>

                                    </div>
                                </li>

                                {noData && (
                                    <div className="text-center content-space-1">
                                        <br/><br/>
                                        <img src={imgNoData} className="avatar avatar-xl mb-3" alt="Facturas"/>
                                        <p className="card-text">No hay facturas para mostrar</p>
                                        <br/><br/>
                                    </div>
                                )}

                                {transactions.map((doc, key) => {
                                    return(
                                        <li key={key} className="card card-bordered shadow-none mb-3">
                                            <Order
                                                id={doc.id}
                                                invoiceNumber={doc.invoiceNumber}
                                                totalTime={doc.totalTime}
                                                price={doc.totalPrice}
                                                shippedDate={doc.date}
                                                file={doc.file}
                                            />
                                        </li>
                                    )
                                })}

                            </ul>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}